import actionTypes from "./actionTypes";
//import {set as setGA} from "react-ga";

const initialState = {
    profile: undefined,
    authenticate: {
        // forgerock authenticate state
    },
    details: {}
};

export default function authenticate(state = initialState, action) {
    switch (action.type) {
        case actionTypes.CLEAR_STATE: {
            return initialState;
        }
        case actionTypes.START_AUTHENTICATION: {
            const {payload} = action;
            return {
                ...state,
                authenticate: payload
            }
        }
        case actionTypes.AUTHENTICATE_SUCCESS:
        case actionTypes.AUTHENTICATE_STEP: {
            const {payload} = action;
            return {
                ...state,
                authenticate: payload
            };
        }
        case actionTypes.SET_USER_PROFILE: {
            const {payload} = action;
            //setGA({userId: (payload && payload.username) || (payload || payload.cn) || "Unknown"});
            return {
                ...state,
                profile: payload
            };
        }
        case actionTypes.CLEAR_AUTHENTICATION: {
            return {
                ...state,
                authenticate:undefined,
                profile:undefined
            }
        }
        case actionTypes.CAPTCHA_REQUIRED: {
            const {payload} = action;
            return {
                ...state,
                captchaSiteKey:payload
            }
        }
        case actionTypes.CLEAR_CAPTCHA_SUCCESS: {
            return {
                ...state,
                captchaSiteKey:undefined
            }
        }
        case actionTypes.SET_AUTH_DETAILS: {
            return {
                ...state,
                details: action.payload
            }
        }
        case actionTypes.SET_AUTH_SUCCESS: {
            return {
                ...state,
                details: { data: true }
            }
        }
        default:
            return state;
    }
}
